import { BaseDto } from "../common/baseDto";

export interface TqcInspectResultHdrDto extends BaseDto {
	inspectNo: string;
	inspectDt: string | undefined;
	compCd: string;
	compNm: string;
	inspectType: string;
	inspectTypeNm: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	supplierCustom: string;
	supplierCustomNm: string;
	workplaceCd: string;
	workplaceNm: string;
	jobTeam: string;
	itemCd: string;
	itemNm: string;
	workerEmp: string;
	workerEmpNm: string;
	inspectQty: number;
	badQty: number;
	acceptQty: number;
	badCase: string;
	badCaseNm: string;
	basOrderNo: string;
	basOrderItemno: string;
	basLotNo: string;
	judgeEmpno: string;
	judgeEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	remark: string;
}

export const defaultTqcInspectResultHdrDto: TqcInspectResultHdrDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	inspectNo: "",
	inspectDt: undefined,
	compCd: "",
	compNm: "",
	inspectType: "",
	inspectTypeNm: "",
	inspectorEmp: "",
	inspectorEmpNm: "",
	supplierCustom: "",
	supplierCustomNm: "",
	workplaceCd: "",
	workplaceNm: "",
	jobTeam: "",
	itemCd: "",
	itemNm: "",
	workerEmp: "",
	workerEmpNm: "",
	inspectQty: 0,
	badQty: 0,
	acceptQty: 0,
	badCase: "",
	badCaseNm: "",
	basOrderNo: "",
	basOrderItemno: "",
	basLotNo: "",
	judgeEmpno: "",
	judgeEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	remark: "",
};

export interface TqcInspectResultDtlDto extends BaseDto {
	inspectNo: string;
	itemNo: string;
	inspectDt: string | undefined;
	itemCd: string;
	basOrderNo: string;
	basOrderItemno: string;
	basLotNo: string;
	inspectValue1_1: string;
	inspectValue1_2: string;
	inspectValue1_3: string;
	inspectValue1_4: string;
	inspectValue1_5: string;
	inspectValue2_1: string;
	inspectValue2_2: string;
	inspectValue2_3: string;
	inspectValue2_4: string;
	inspectValue2_5: string;
	inspectValue3_1: string;
	inspectValue3_2: string;
	inspectValue3_3: string;
	inspectValue3_4: string;
	inspectValue3_5: string;
	remark: string;
}

export const defaultTqcInspectResultDtlDto: TqcInspectResultDtlDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	inspectNo: "",
	itemNo: "",
	inspectDt: undefined,
	itemCd: "",
	basOrderNo: "",
	basOrderItemno: "",
	basLotNo: "",
	inspectValue1_1: "",
	inspectValue1_2: "",
	inspectValue1_3: "",
	inspectValue1_4: "",
	inspectValue1_5: "",
	inspectValue2_1: "",
	inspectValue2_2: "",
	inspectValue2_3: "",
	inspectValue2_4: "",
	inspectValue2_5: "",
	inspectValue3_1: "",
	inspectValue3_2: "",
	inspectValue3_3: "",
	inspectValue3_4: "",
	inspectValue3_5: "",
	remark: "",
};
